import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'action-button',
	templateUrl: './action-button.component.html',
	styleUrls: ['./action-button.component.scss', '../stylesheets/job-actions.scss']
})
export class ActionButtonComponent implements OnInit {

	@Input() public icon: string;
	@Input() public name: string;
	@Input() public subpage: string;
	@Input() public disabled = false;
	private _badge: { hasBadge?: boolean, value?: string } = { hasBadge: false };
	@Input() public set badge(value: { hasBadge?: boolean, value?: string }) {
		this._badge = value;
	}
	public get badge() {
		return this._badge;
	}
	@Input() public clickAction: () => void;

	constructor(
		public elementRef: ElementRef
	) { }

	ngOnInit(): void {
	}

}
